import React, { useRef } from 'react';

import { useIsOverflowing } from '@shared/hooks';
import { Icon, Flex, UiText, UiButton } from '@shared/ui';

import cls from './CardError.module.css';

export const CardError = ({
    textError = 'Некоторая ошибка с очень большим текстом и показ как будет вести себя подсказка подсказка подсказка подсказка',
    onRetry,
}: {
    textError: string;
    onRetry?: () => void;
}) => {
    const textRef = useRef(null);
    const { isOverflowing } = useIsOverflowing({ elRef: textRef });

    return (
        <Flex
            direction="column"
            align="center"
            justify="between"
            className={cls.CardErrorContainer}
        >
            <Flex direction="column" justify="center" align="center" gap={8}>
                <span className={cls.iconWrapper}>
                    <Icon iconName="popupWarning" fill="#ec3030" width={36} height={36} />
                </span>
                <UiText
                    variant="plain"
                    className={cls.ErrorText}
                    title={isOverflowing ? textError : ''}
                    ref={textRef}
                    align="center"
                >
                    {textError}
                </UiText>
            </Flex>
            <UiButton
                btnText="Повторить"
                onClick={(e) => {
                    e.stopPropagation();
                    onRetry?.();
                }}
            />
        </Flex>
    );
};
